<template>
  <p class="max-w-2xl text-lg">
    <slot />
  </p>
</template>
